import { GetServerSideProps } from "next";
import { ReactElement } from "react";
import FastDebtConsolidationWrapper from "@components/layouts/fastDebtConsolidationWrapper";
import { useDomainContext } from "@hooks/useDomainContext";

import { getPageProps } from "@services/initial-calls";
import PrivacyPolicy from "@components/shared/legal/privacyPolicy";

export default function FastDebtConsolidationHome(): ReactElement {
    const { domain } = useDomainContext();
    return (
        <FastDebtConsolidationWrapper>
            <PrivacyPolicy
                category={domain?.categories[0]?.name}
                domain={domain.niceName}
            />
        </FastDebtConsolidationWrapper>
    );
}

export const getServerSideProps: GetServerSideProps = async (context) => {
    return await getPageProps(context, "home", { pageTitle: "Privacy Policy" });
};
